import React from 'react';
import styles from './TopNav.module.scss';
import PropTypes from 'prop-types';
import TipsiconHOC from './TipsiconHoc';
import { getLocalStorage } from '@/assets/js/storage';

class TopNav extends React.Component {

    state = {
        active: -1,
    }
    firstCardPath = '';

    componentDidMount() {
        const { navlist, firstCardPath, match } = this.props;
        for (let i = 0; i < navlist.length; i++) {
            if (match.path + navlist[i].path == firstCardPath) {
                this.setState({ active: i });
                break;
            }
        }
        this.firstCardPath = firstCardPath;
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.firstCardPath != newProps.firstCardPath) {
            const { navlist, firstCardPath, match } = this.props;
            let topActive = false;
            for (let i = 0; i < navlist.length; i++) {
                if (match.path + navlist[i].path == firstCardPath) {
                    this.setState({ active: i });
                    topActive = true;
                    break;
                }
            }
            if (!topActive) {
                this.setState({ active: -1 });
            }
            this.firstCardPath = firstCardPath;
        }
    }

    simpleEncrypt(text, shift) {
        return text.split('').map(function (char) {
            if (char.match(/[a-zA-Z]/)) {
                // 将字符ASCII码转换成数字，并加上移位值
                var code = char.charCodeAt(0) + shift;
                // 确保在'a'和'z'之间循环
                if (code > 'z'.charCodeAt(0)) {
                    code -= 26;
                } else if (code < 'a'.charCodeAt(0)) {
                    code += 26;
                }
                return String.fromCharCode(code);
            }
            return char; // 非字母字符不变
        }).join('');
    }

    simpleDecrypt(encryptedText, shift) {
        return this.simpleEncrypt(encryptedText, -shift);
    }

    _renderTopNav = () => {
        const { match, navlist, firstCardHandle } = this.props;
        const { active } = this.state;
        return (
            <ul className={styles.ul}>
                {
                    navlist.map((item, index) => {
                        return (
                            <div
                                key={index}
                                className={`${styles.item} ${styles.item_active}`}
                                onClick={() => {
                                    if (item.path == '/ais') {
                                        const auth = getLocalStorage('auth') ? JSON.parse(getLocalStorage('auth')) : null;
                                        if (auth) {
                                            const loginName = auth.loginName;
                                            const loginPwd = this.simpleEncrypt(auth.loginPwd, 2);

                                            var tempwin = window.open('about:blank');
                                            tempwin.location = 'https://ais.phkjian.com?loginName=' + loginName + '&loginPwd=' + loginPwd;
                                            return;
                                        }
                                    }

                                    this.setState({ active: index });
                                    firstCardHandle(match.path + item.path);
                                }}>{
                                    active == index ? <div className={styles.active} >
                                        <img className={styles.icon} src={item.icon_down} />
                                        <div className={styles.title}>{item.title}</div>
                                    </div> : <div className={styles.hover_div}>
                                        <img className={styles.icon} src={item.icon_up} />
                                        <div className={styles.hover_title}>{item.title}</div>
                                    </div>
                                }
                            </div>
                        );
                    })
                }
            </ul>
        );
    }

    render() {
        return (
            <div className={styles.container}>
                {this._renderTopNav()}
            </div>
        );
    }
}

TopNav.defaultProps = {
    navlist: [
        {
            path: '/workbench',
            icon_up: (require('@/assets/image/topnav/workbench_up.png').default),
            icon_down: (require('@/assets/image/topnav/workbench_down.png').default),
            title: '工作台',
        },
        {
            path: '/operation',
            icon_up: (require('@/assets/image/topnav/operation_up.png').default),
            icon_down: (require('@/assets/image/topnav/operation_down.png').default),
            title: '市场管理',
        },
        {
            path: '/audit',
            icon_up: (require('@/assets/image/topnav/audit_up.png').default),
            icon_down: (require('@/assets/image/topnav/audit_down.png').default),
            title: '审核管理',
        },
        {
            path: '/user',
            icon_up: (require('@/assets/image/topnav/user_up.png').default),
            icon_down: (require('@/assets/image/topnav/user_down.png').default),
            title: '用户管理',
        },
        {
            path: '/order',
            icon_up: (require('@/assets/image/topnav/order_up.png').default),
            icon_down: (require('@/assets/image/topnav/order_down.png').default),
            title: '订单管理',
        },
        {
            path: '/market',
            icon_up: (require('@/assets/image/topnav/market_up.png').default),
            icon_down: (require('@/assets/image/topnav/market_down.png').default),
            title: '营销管理',
        },
        {
            path: '/contract',
            icon_up: (require('@/assets/image/topnav/contract_up.png').default),
            icon_down: (require('@/assets/image/topnav/contract_down.png').default),
            title: '合同管理',
        },
        {
            path: '/client',
            icon_up: (require('@/assets/image/topnav/client_up.png').default),
            icon_down: (require('@/assets/image/topnav/client_down.png').default),
            title: '客户端管理',
        },
        {
            path: '/finance',
            icon_up: (require('@/assets/image/topnav/finance_up.png').default),
            icon_down: (require('@/assets/image/topnav/finance_down.png').default),
            title: '财务管理',
        },
        {
            path: '/permissions',
            icon_up: (require('@/assets/image/topnav/permissions_up.png').default),
            icon_down: (require('@/assets/image/topnav/permissions_down.png').default),
            title: '权限管理',
        },
        {
            path: '/aftersale',
            icon_up: (require('@/assets/image/topnav/aftersale_up.png').default),
            icon_down: (require('@/assets/image/topnav/aftersale_down.png').default),
            title: '售后管理',
        }, {
            path: '/system',
            icon_up: (require('@/assets/image/topnav/system_up.png').default),
            icon_down: (require('@/assets/image/topnav/system_down.png').default),
            title: '系统管理',
        }, {
            path: '/report',
            icon_up: (require('@/assets/image/topnav/report_up.png').default),
            icon_down: (require('@/assets/image/topnav/report_down.png').default),
            title: '报表管理',
        },
    ]
};

TopNav.propTypes = {
    match: PropTypes.object,
    navlist: PropTypes.array,
    firstCardPath: PropTypes.string, // 一级导航路径
    firstCardHandle: PropTypes.func, // 点击一级导航
};

export default TipsiconHOC(TopNav);